module.exports = __webpack_public_path__ + "img/home_bnaner4.b1baaf90.jpg";